import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mainSurvey" }
const _hoisted_2 = { class: "with-margin" }
const _hoisted_3 = { class: "with-margin" }
const _hoisted_4 = {
  key: 0,
  class: "with-margin"
}
const _hoisted_5 = { class: "mainSurvey-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radio_button = _resolveComponent("radio-button")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.isCallSurvey ? _ctx.$t('survey_09_01_call') : _ctx.$t('survey_09_01')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('survey_09_02_call')), 1),
      _createVNode(_component_radio_button, {
        text: _ctx.data,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.change($event))),
        value: _ctx.getAge
      }, null, 8, ["text", "value"]),
      (!_ctx.isCallSurvey)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('survey_09_02')), 1))
        : _createCommentVNode("", true),
      (!_ctx.isCallSurvey)
        ? (_openBlock(), _createBlock(_component_radio_button, {
            key: 1,
            text: _ctx.gender,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.genderChange($event))),
            value: _ctx.getGender
          }, null, 8, ["text", "value"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        class: "footer-button",
        size: 'large',
        text: _ctx.$t('previous'),
        type: 'outlined',
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goBack()))
      }, null, 8, ["text"]),
      _createVNode(_component_Button, {
        class: "footer-button",
        size: 'large',
        text: _ctx.$t('next'),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.nextScreen()))
      }, null, 8, ["text"])
    ])
  ]))
}